import { getCreditCardEncryptionKey } from '~/components/payment-beta/deposit/api/credit-card';

const { default: JSEncrypt } = await import('jsencrypt');

export const encryptStringWithRsaPublicKey = (toEncrypt: string, publicKey: string) => {
	const encrypt = new JSEncrypt();
	encrypt.setPublicKey(publicKey);

	return encrypt.encrypt(toEncrypt);
};

export const encryptCCData = async (data: Record<string, unknown>) => {
	try {
		const creditCardEncryptResponse = await getCreditCardEncryptionKey();
		const publicKey = creditCardEncryptResponse?.result;

		if (publicKey && publicKey !== '') {
			const encryptAll = await Promise.all(
				Object.keys(data)?.map(key => {
					const encyptedItem = encryptStringWithRsaPublicKey(data[key] as string, publicKey);
					return { [key]: data[key] ? encyptedItem : data[key] };
				})
			);

			const encryptedData = encryptAll.reduce((acc, result) => ({ ...acc, ...result }), {});
			return encryptedData;
		}
		return data;
	} catch (err) {
		return {};
	}
};

export enum CardType {
	'default-card' = 'default-card',
	amex = 'amex',
	visaelectron = 'visaelectron',
	jcb = 'jcb',
	/* entropay = 'entropay', */
	mastercard = 'mastercard',
	maestro = 'maestro',
	/* ecard = 'ecard', */
	visa = 'visa'
}

const cardTypePatterns: { [key in CardType]?: RegExp } = {
	[CardType.amex]: /^3[47][0-9]{0,13}$/,
	[CardType.visa]: /^4/,
	[CardType.visaelectron]: /^(417500|4917|4913|4508|4844)/,
	[CardType.jcb]: /^(35|18|21)/,
	/* [CardType.entropay]: /^(35|18|21)/, */
	[CardType.mastercard]: /^5[1-5][0-9]{0,14}$/,
	[CardType.maestro]: /^(50|56|57|58|60|63|64|66|67)/
	/* [CardType.ecard]: /^(430706|402360|533980|529926)/ */
};

export function getCardType(cardNumber?: string): CardType {
	const cards = Object.keys(CardType);

	for (let i = 0; i < cards.length; i += 1) {
		const regex = cardTypePatterns[cards[i] as CardType];

		if (regex && regex.test(cardNumber ?? '')) {
			return cards[i] as CardType;
		}
	}

	return CardType['default-card'];
}
